<template>
  <nav
    class="v3kiosk-step-nav"
    :aria-label="$t('kiosk.nav_aria_label')"
    data-testid="kiosk-step-nav"
  >
    <ol class="v3kiosk-step-nav__list">
      <li
        v-for="step in steps"
        :key="step.id"
        class="v3kiosk-step-nav__item"
        :class="{
          'v3kiosk-step-nav__item--active': step.id === currentStep,
          'v3kiosk-step-nav__item--completed': step.id < currentStep
        }"
        :aria-current="step.id === currentStep ? 'step' : undefined"
        :data-testid="`kiosk-step-nav-item-${step.id}`"
      >
        <span class="v3kiosk-step-nav__indicator" aria-hidden="true">
          {{ step.id }}
        </span>
        <span class="v3kiosk-step-nav__label">{{ $t(step.labelKey) }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
import { KIOSK_NAV_STEPS } from "@/constants/kioskConstants"

export default {
  name: "KioskStepNav",

  props: {
    currentStep: {
      type: Number,
      default: 1,
      validator: (value) => value >= 1 && value <= KIOSK_NAV_STEPS.length
    }
  },

  setup() {
    const steps = KIOSK_NAV_STEPS

    return {
      steps
    }
  }
}
</script>
